import { render, staticRenderFns } from "./NoVNC.vue?vue&type=template&id=85c86464&"
import script from "./NoVNC.vue?vue&type=script&lang=js&"
export * from "./NoVNC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports